import React, {useState, useContext} from 'react';
import Sugar from 'sugar';

// import styles from './assets/scss/modules/scorecard-figure.module.scss';

Sugar.extend();

const OpenContext = React.createContext();

function ScorecardExpandablePanel( {children, className, style, onClick, startOpen} ) {

  const [open, setOpen] = useState( startOpen );
  const toggleOpen = () => setOpen( !open );
  const openClass = open ? 'open' : '';

  return (
    <OpenContext.Provider value={{ open, toggleOpen }}>
      <div className={`scorecard-item ${className} ${ openClass }`} style={style} onClick={ onClick }>
        { children }
      </div>
    </OpenContext.Provider>
  );
}


ScorecardExpandablePanel.defaultProps = {
  startOpen: false
}

function useOpenContext() {
  const context = useContext(OpenContext);

  if (!context) {
    throw new Error(
      `Toggle compound components cannot be rendered outside the Toggle component`,
    )
  }

  return context;
}

function Open({children})
{
  const {open} = useOpenContext();
  return open ? children : null;
}

function Closed({children})
{
  const {open} = useOpenContext();
  return open ? null : children;
}

function ToggleButton({children})
{
  const {toggleOpen} = useOpenContext();
  return (
    <span onClick={ toggleOpen }>
      { children }
    </span>
  )
}

ScorecardExpandablePanel.Open = Open
ScorecardExpandablePanel.Closed = Closed
ScorecardExpandablePanel.ToggleButton = ToggleButton


export default ScorecardExpandablePanel;
